import { useEffect, useRef, useState } from "react";
import "./ExamSecurity.css";

const ExamSecurity = ({ submitTest }) => {
  const warningCount = useRef(0);
  const testSubmitted = useRef(false);
  const submitTimer = useRef(null);

  const escTriggered = useRef(false);

  const [warning, setWarning] = useState(null);

  useEffect(() => {
    // const showWarning = (message) => {
    //   if (testSubmitted.current) return;

    //   warningCount.current += 1;

    //   const count = warningCount.current;
    //   if (count > 3) {
    //     testSubmitted.current = true;

    //     setWarning({
    //       message:
    //         "Maximum warnings exceeded. Your test will be submitted automatically.",
    //       count,
    //       forceSubmit: true,
    //     });

    //     submitTimer.current = setTimeout(() => {
    //       submitTest();
    //     }, 1500);

    //     return;
    //   }

    //   setWarning({
    //     message,
    //     count,
    //     forceSubmit: false,
    //   });
    // };

    const showWarning = (message) => {
      if (testSubmitted.current) return;

      warningCount.current += 1;

      const count = warningCount.current;

      /*
       * FIRST 3 VIOLATIONS
       */
      if (count <= 3) {
        setWarning({
          message,
          count,
          forceSubmit: false,
        });

        return;
      }

      /*
       * 4TH VIOLATION
       */
      testSubmitted.current = true;

      setWarning({
        message:
          "Maximum warnings exceeded. Your test is being submitted automatically.",
        count,
        forceSubmit: true,
      });

      /*
       * Submit after popup is displayed.
       */
      setTimeout(() => {
        try {
          if (typeof submitTest === "function") {
            submitTest();
          } else {
            console.error("ExamSecurity: submitTest is not a function");
          }
        } catch (error) {
          console.error("Exam submission failed:", error);
        }
      }, 1500);
    };
    const handleBeforeUnload = (e) => {
      if (testSubmitted.current) return;

      e.preventDefault();
      e.returnValue = "";

      return "";
    };
    const handleKeyDown = (e) => {
      const key = e.key.toLowerCase();
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        escTriggered.current = true;

        showWarning("Escape key is not allowed during the test.");

        return;
      }
      if (e.key === "F5") {
        e.preventDefault();

        showWarning("Browser refresh is not allowed during the test.");

        return;
      }
      if ((e.ctrlKey || e.metaKey) && key === "r") {
        e.preventDefault();

        showWarning("Browser refresh is not allowed during the test.");

        return;
      }

      if ((e.ctrlKey || e.metaKey) && e.shiftKey && key === "r") {
        e.preventDefault();

        showWarning("Hard refresh is not allowed during the test.");

        return;
      }

      if ((e.ctrlKey || e.metaKey) && key === "c") {
        e.preventDefault();

        showWarning("Copying content is not allowed during the test.");

        return;
      }

      if ((e.ctrlKey || e.metaKey) && key === "v") {
        e.preventDefault();

        showWarning("Pasting content is not allowed during the test.");

        return;
      }

      if ((e.ctrlKey || e.metaKey) && key === "x") {
        e.preventDefault();

        showWarning("Cutting content is not allowed during the test.");

        return;
      }

   
      if ((e.ctrlKey || e.metaKey) && key === "a") {
        e.preventDefault();

        showWarning("Select All is not allowed during the test.");

        return;
      }
    };


    const handleCopy = (e) => {
      e.preventDefault();

      showWarning("Copying content is not allowed during the test.");
    };

    const handlePaste = (e) => {
      e.preventDefault();

      showWarning("Pasting content is not allowed during the test.");
    };

    const handleCut = (e) => {
      e.preventDefault();

      showWarning("Cutting content is not allowed during the test.");
    };

    const handleContextMenu = (e) => {
      e.preventDefault();

      showWarning("Right-click is not allowed during the test.");
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        showWarning(
          "You switched away from the test. Please stay on the test page.",
        );
      }
    };

    const handleFullscreenChange = () => {
      const isFullscreen = !!document.fullscreenElement;

      if (!isFullscreen) {
        if (escTriggered.current) {
          escTriggered.current = false;
          return;
        }

        showWarning(
          "You exited fullscreen mode. Please remain in fullscreen mode during the test.",
        );
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);

    document.addEventListener("copy", handleCopy);

    document.addEventListener("paste", handlePaste);

    document.addEventListener("cut", handleCut);

    document.addEventListener("contextmenu", handleContextMenu);

    document.addEventListener("visibilitychange", handleVisibilityChange);

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    window.addEventListener("beforeunload", handleBeforeUnload);

    /*
     * ==========================================
     * CLEANUP
     * ==========================================
     */
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);

      document.removeEventListener("copy", handleCopy);

      document.removeEventListener("paste", handlePaste);

      document.removeEventListener("cut", handleCut);

      document.removeEventListener("contextmenu", handleContextMenu);

      document.removeEventListener("visibilitychange", handleVisibilityChange);

      document.removeEventListener("fullscreenchange", handleFullscreenChange);

      window.removeEventListener("beforeunload", handleBeforeUnload);

      if (submitTimer.current) {
        clearTimeout(submitTimer.current);
      }
    };
  }, [submitTest]);

  const handleContinue = async () => {
   
    setWarning(null);

    escTriggered.current = false;

    if (!document.fullscreenElement) {
      try {
        await document.documentElement.requestFullscreen();
      } catch (error) {
        console.warn("Could not re-enter fullscreen:", error);
      }
    }
  };

  return (
    <>
      {warning && (
        <div className="exam-security-overlay">
          <div className="exam-security-popup">
            {/* Warning Icon */}
            <div className="exam-security-icon">!</div>

            {/* Heading */}
            <h2>Security Warning</h2>

            {/* Message */}
            <p className="exam-security-message">{warning.message}</p>

            {/* Normal Warning */}
            {!warning.forceSubmit && (
              <>
                <div className="exam-security-count">
                  Warning {warning.count} of 3
                </div>

                <div className="exam-security-progress">
                  <div
                    className="exam-security-progress-bar"
                    style={{
                      width: `${Math.min((warning.count / 3) * 100, 100)}%`,
                    }}
                  />
                </div>

                <p className="exam-security-info">
                  Please follow the test rules. Repeated violations will result
                  in automatic submission.
                </p>

                <button
                  type="button"
                  className="exam-security-button"
                  onClick={handleContinue}
                >
                  Continue Test
                </button>
              </>
            )}

            {/* Automatic Submission */}
            {warning.forceSubmit && (
              <div className="exam-security-submitting">Submitting test...</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ExamSecurity;
